module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/802d49285fc44414f08354b2fa5544cf.png";